import React from "react";

const AshbyIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2773_1226)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34 0H6C2.68629 0 0 2.68629 0 6V34C0 37.3137 2.68629 40 6 40H34C37.3137 40 40 37.3137 40 34V6C40 2.68629 37.3137 0 34 0Z",
  fill: "url(#paint0_linear_2773_1226)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.112 29.123C30.407 29.845 30.725 30.387 31.065 30.748C31.429 31.086 31.78 31.268 32.121 31.29V31.967C30.486 31.899 28.421 31.865 25.923 31.865C23.334 31.865 21.427 31.899 20.201 31.967V31.29C21.064 31.244 21.677 31.143 22.04 30.985C22.403 30.805 22.585 30.5 22.585 30.071C22.585 29.665 22.449 29.123 22.176 28.446L20.166 22.894H13.287L12.708 24.418C11.959 26.336 11.584 27.803 11.584 28.818C11.584 29.744 11.845 30.376 12.368 30.714C12.89 31.053 13.662 31.244 14.684 31.29V31.967C13.1974 31.9039 11.7098 31.8699 10.222 31.865C9.15498 31.865 8.28098 31.899 7.59998 31.967V31.29C8.16698 31.2 8.69998 30.85 9.19998 30.24C9.69998 29.63 10.21 28.66 10.733 27.329L18.293 8C19.02 8.045 19.622 8.068 20.099 8.068C20.553 8.068 21.143 8.045 21.869 8L30.112 29.123ZM19.929 22.218L16.829 13.755L13.559 22.218H19.929Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2773_1226",
  x1: 20,
  y1: 0,
  x2: 20,
  y2: 40,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3F34BC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5246D8"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2773_1226"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(AshbyIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;